var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 37C74 16.5661 57.4339 0 37 0C16.566 0 0 16.5634 0 37C0 57.4366 16.566 74 37 74C57.4339 74 74 57.4339 74 37ZM58.555 54.5251H43.2455V53.4093C45.0041 53.2526 46.1384 53.064 46.6485 52.8382C47.1585 52.6124 47.4109 52.0625 47.4109 51.1858C47.4109 50.8936 47.3126 50.3756 47.116 49.6371C46.9194 48.8985 46.6458 48.1149 46.2925 47.2967L43.883 41.5055H28.0183C26.4536 45.4424 25.5212 47.8466 25.2183 48.7152C24.9155 49.5839 24.7641 50.2693 24.7641 50.7767C24.7641 51.7915 25.1732 52.4928 25.9967 52.8833C26.5041 53.1171 27.4631 53.2924 28.8711 53.4093V54.5277H16.9433V53.4093C18.492 53.234 19.6529 52.6522 20.426 51.6613C21.199 50.6704 22.5273 47.9635 24.4054 43.5324L36.9469 13.9892H38.1476L53.1463 48.1175C54.1452 50.3782 54.9448 51.7756 55.5425 52.3122C56.1402 52.8488 57.1444 53.2127 58.555 53.4067V54.5251Z",
    fill: "#DB2B42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.041 39.0641H42.8709L35.9719 22.4848L29.041 39.0641Z",
    fill: "#DB2B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.40d256345ee85978a67645f1fa7974c7.svg";
export { ForwardRef as ReactComponent };